import { styled } from 'stitches.config'

const colorVariants = {
  primary: {
    color: '$primary-500'
  },
  secondary: {
    color: '$accent-white'
  }
}

const textStyles = {
  fontWeight: '$semiBold',
  letterSpacing: '1px',
  textAlign: 'center',

  variants: {
    color: colorVariants,
  },

  defaultVariants: {
    color: 'primary'
  }
}

export const ReviewsRoot = styled('div', {
  backgroundColor: '$accent-white',
  width: '100%',

  '& strong': {
    fontWeight: '$semiBold',
  },


})

export const SectionTitle = styled('h2', {
  ...textStyles,
  fontSize: '$h2',
  lineHeight: '$h1',
  fontWeight: '$regular',

  '@bp3': {
    fontSize: '$h1',
    textAlign: 'left',
  },

  variants: {
    ...textStyles.variants,
    align: {
      center: {
        textAlign: 'center',
        '@bp3': { textAlign: 'center' },
      },
    },
  },
})

export const Subtitle = styled('h3', {
  ...textStyles,
  color: '$accent-black',
  fontSize: '$h4',
  lineHeight: '$h4',
  marginTop: '24px',
})

